export const moduleLinks = {
  default: [
    {
      id: 1,
      value: "gis",
      name: "GIS",
      icon: "ksodd",
      routesLinks: [
        {
          id: 1,
          value: "map",
          to: "/app/map",
          name: "Map",
          icon: "ksodd-map"
        },
        {
          id: 2,
          value: "book",
          to: "/app/book",
          name: "Book",
          icon: "ksodd-tables"
        },
        {
          id: 3,
          value: "charts",
          to: "/app/charts",
          name: "Chart",
          icon: "ksodd-graphs"
        }
      ]
    },
    {
      id: 2,
      value: "mtp",
      name: "MTP",
      icon: "modelling",
      routesLinks: [
        {
          id: 0,
          value: "calculations",
          to: "/app/calculations",
          name: "Calculations",
          icon: "modelling"
        },
        {
          id: 1,
          value: "scenario-modelling",
          to: "/app/scenario-modelling",
          name: "Scenario Modelling",
          icon: "modelling-calculate"
        },
        {
          id: 2,
          value: "traffic-counts",
          to: "/app/traffic-count",
          name: "Traffic Counts",
          icon: "modelling-intense"
        },
        {
          id: 3,
          value: "public-transport",
          to: "/app/public-transport",
          name: "PT Registry",
          icon: "modelling-transport"
        }
        // {
        //   id: 5,
        //   value: "modelling",
        //   to: "/app/modelling",
        //   name: "Modelling",
        //   icon: "modelling"
        // },
      ]
    },
    {
      id: 3,
      value: "situation-center",
      name: "Situation Center",
      icon: "s-center",
      routesLinks: [
        {
          id: 1,
          value: "situation-center",
          to: "/app/situation-center",
          name: "Situation Center",
          icon: "s-center"
        },
        {
          id: 2,
          value: "event-editor",
          to: "/app/event-editor",
          name: "Event editor",
          icon: "s-center-editor"
        }
      ]
    }
  ],
  chelyabinsk: [
    {
      id: 1,
      value: "gis",
      name: "GIS",
      icon: "ksodd",
      routesLinks: [
        {
          id: 1,
          value: "map",
          to: "/app/map",
          name: "Map",
          icon: "ksodd-map"
        },
        {
          id: 2,
          value: "book",
          to: "/app/book",
          name: "Book",
          icon: "ksodd-tables"
        },
        {
          id: 3,
          value: "charts",
          to: "/app/charts",
          name: "Chart",
          icon: "ksodd-graphs"
        }
      ]
    },
    {
      id: 2,
      value: "situation-center",
      name: "Situation Center",
      icon: "s-center",
      routesLinks: [
        {
          id: 1,
          value: "situation-center",
          to: "/app/situation-center",
          name: "Situation Center",
          icon: "s-center"
        },
        {
          id: 2,
          value: "event-editor",
          to: "/app/event-editor",
          name: "Event editor",
          icon: "s-center-editor"
        }
      ]
    }
  ],
  tagil: [
    {
      id: 1,
      value: "gis",
      name: "GIS",
      icon: "ksodd",
      routesLinks: [
        {
          id: 1,
          value: "map",
          to: "/app/map",
          name: "Map",
          icon: "ksodd-map"
        },
        {
          id: 2,
          value: "book",
          to: "/app/book",
          name: "Book",
          icon: "ksodd-tables"
        },
        {
          id: 3,
          value: "charts",
          to: "/app/charts",
          name: "Chart",
          icon: "ksodd-graphs"
        }
      ]
    },
    {
      id: 2,
      value: "situation-center",
      name: "Situation Center",
      icon: "s-center",
      routesLinks: [
        {
          id: 1,
          value: "situation-center",
          to: "/app/situation-center",
          name: "Situation Center",
          icon: "s-center"
        },
        {
          id: 2,
          value: "event-editor",
          to: "/app/event-editor",
          name: "Event editor",
          icon: "s-center-editor"
        }
      ]
    }
  ]
};

export const actionLinks = {
  default: [
    {
      id: 1,
      value: "change-log",
      icon: "notification"
    },
    {
      id: 2,
      value: "user-roles",
      name: "UserRoles",
      icon: "users",
      to: "/app/user-roles"
    },
    {
      id: 3,
      value: "proposal",
      name: "Proposal",
      icon: "proposal",
      to: "/app/proposal"
    },
    {
      id: 4,
      value: "ds-manager",
      name: "DataSourceManager",
      icon: "database"
    }
  ],
  chelyabinsk: [
    {
      id: 1,
      value: "change-log",
      icon: "notification"
    },
    {
      id: 2,
      value: "user-roles",
      name: "UserRoles",
      icon: "users",
      to: "/app/user-roles"
    },
    {
      id: 3,
      value: "ds-manager",
      name: "DataSourceManager",
      icon: "database"
    }
  ],
  tagil: [
    {
      id: 1,
      value: "change-log",
      icon: "notification"
    },
    {
      id: 2,
      value: "user-roles",
      name: "UserRoles",
      icon: "users",
      to: "/app/user-roles"
    },
    {
      id: 3,
      value: "ds-manager",
      name: "DataSourceManager",
      icon: "database"
    }
  ]
};

export const accountActionList = [
  {
    value: "title",
    name: "account",
    devided: false
  },
  {
    value: "about",
    name: "about",
    devided: false
  },
  {
    value: "theme",
    name: "theme",
    devided: true
  },
  {
    value: "lang",
    name: "lang",
    devided: false
  },
  {
    value: "settings-reset",
    name: "settings-reset",
    devided: false
  },
  {
    value: "exit",
    name: "exit",
    devided: true
  }
];
